import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GameButton from '../game-button/gameButton';
import ShareFBTwitter from '../share-fb-twitter/shareFBTwitter';
import AppStoreIcons from '../app-store-icons/appStoreIcons';
import InterstitialAd from '../interstitial-ad/interstitialAd';
import Strings from '../../strings.json';

import './gameEnd.css';


export default class GameEnd extends Component {

  constructor(props) {
    super(props);

    this.onAdShown = this.onAdShown.bind(this);

    this.gifImageDir = '/images/gifs';
    this.averageScore = 3.2;
    this.averageScoreSentance = `The average score is ${this.averageScore}.`;
    this.strings = Strings.gameEnd.messages;

    this.state = {
      showAd: this.props.showAd
    };

    this.gifUrl = this.getRandomGifImageUrl(this.props.score, Strings.gameEnd.gifCount);
    this.message = this.getGameEndMessage(this.props.score);
  }

  componentDidMount() {
    if (this.bannerAdContainer !== undefined) {
      var iframe = document.createElement('iframe');
      iframe.src = '/rubicon-banner.html?ad_type=banner2';
      this.bannerAdContainer.appendChild(iframe);
    }
  }

  getGameEndMessage(score) {

    var messageType = 'beta';

    if (score >= 0 && score <= 2) {
      messageType = 'alpha';
    } else if (score >= 5 && score <= 8) {
      messageType = 'charlie';
    } else if (score >= 9 && score <= 20) {
      messageType = 'delta';
    } else if (score >= 21) {
      messageType = 'echo';
    }

    let messages = this.strings[messageType]; 
    let messageIndex = this.randomNumberFromRange(0, messages.length - 1);

    return messages[messageIndex]
    .replace('##AVERAGE_SCORE_SENTANCE##', this.averageScoreSentance)
    .replace('##AVERAGE_SCORE##', this.averageScore);
  }

  getRandomGifImageUrl(score, max) {
    let gifType = score >= 5 ? 'good' : 'bad';
    let gifNumber = this.randomNumberFromRange(1, max);
    return `${this.gifImageDir}/${gifType}-${gifNumber}.gif`;
  }

  randomNumberFromRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  onAdShown() {
    this.setState({ showAd: false });
  }

  render() {
    if (this.state.showAd === true) {
      return <InterstitialAd adFinished={this.onAdShown} />
    }

    return (<div className='game-end' style={{backgroundImage: `url(${this.gifUrl})`}}>
      <div className='game-end__wrapper'>
        <div className='game-end-score-wrapper'>
          <p className='game-end-score'>You scored: <span className='game-end-score__score'>{this.props.score}</span></p>
          <div dangerouslySetInnerHTML={{__html: this.message}} />
        </div>
        <ShareFBTwitter />
        <GameButton id='main-menu-btn' customClass='game-button--end' text='Back to menu' clickHandler={this.props.exitGameHandler} />
        <GameButton id='game-over-btn' customClass='game-button--end' text='Play again' clickHandler={this.props.playAgainHandler} />
        <AppStoreIcons placementId='go' />
        <p>Follow us for updates <a target='_blank' rel='noopener noreferrer' href='//twitter.com/higherlowergame'>@HigherLowerGame</a></p>
        <div className='game-end-banner-ad' ref={(ref) => this.bannerAdContainer = this.state.showAd === false ? ref : undefined} />
      </div>
    </div>);
  }
}

GameEnd.propTypes = {
  score: PropTypes.number, 
  showAd: PropTypes.bool,
  playAgainHandler: PropTypes.func,
  exitGameHandler: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/game-end/gameEnd.js